var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-monitor',{attrs:{"data":_vm.data,"constants":_vm.constants,"resId":_vm.resId,"idKey":_vm.idKey,"monitorType":_vm.monitorType,"currentMonitorType":_vm.currentMonitorType}})
}
var staticRenderFns = []

export { render, staticRenderFns }